import React from "react";
import styles from "./StudentTimeTable.module.css";
import { FiEdit2, FiTrash2 } from "react-icons/fi";
import { FaRegClock } from "react-icons/fa";

const StudentTimeTable = ({
  icon,
  heading,
  title,
  staff,
  time,
  onEdit,
  onDelete,
}) => {
  return (
    <div className={styles.fullcard}>
      <div className={styles.card}>
        <div className={styles.topRow}>
          <div className={styles.left}>
            <img src={icon} alt="icon" className={styles.icon} />
            <div className={styles.textBlock}>
              <div className={styles.headingRow}>
                <div className={styles.heading}>{heading}</div>
                <div className={styles.actions}>
                  <FiEdit2 className={styles.editIcon} onClick={onEdit} />
                  <FiTrash2 className={styles.deleteIcon} onClick={onDelete} />
                </div>
              </div>

              <div className={styles.subText}>Title : {title}</div>
            </div>
          </div>
        </div>
        <div className={styles.bottomRow}>
          <div className={styles.staffLine}>
            <span>Staff Assigned :</span>
            <span className={styles.staffName}>{staff}</span>
          </div>

          <div className={styles.time}>
            <FaRegClock />
            <span>{time}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StudentTimeTable;
